import React, { useCallback, useContext, useEffect, useState, useRef } from 'react'
import { RequestContext } from '../../../../context/RequestContext';
import { FaCheckCircle } from 'react-icons/fa';
import { getAppSettings } from '../../../../api/app-setting/app-setting';
import { openModal } from '../../../../service/modal-service';
import { MdDiscount, MdKeyboardDoubleArrowRight, MdKeyboardArrowRight } from 'react-icons/md';
import { HELPER_SERVICE_HOURS } from 'js/part-time-helper-cost';
import { BookingCardHeader } from '@/commons/service-hub/BookingCardHeader';

export const PartTimeHelperBooking = (props) => {
    const helperService = props.helperService
    const elderlyCareService = props.elderlyCareService
    const setRequestForm = props.setRequestForm
    const setIsQuickBook = props.setIsQuickBook;
    const countryName = props.countryName
    const currencyCd = props.currencyCd
    const helperType = props.helperType
    const setIsShowJobScope = props.setIsShowJobScope
    const { title, subtitle, pills } = props
    
    const [ isSystemError, setIsSystemError ] = useState(false);
    const [ errorContent, setErrorContent ]  = useState({'header': "", 'body': ""})
    const [ waInd, setWaInd ] = useState(false)

    // Refs and state for horizontal scrolling on mobile
    const helperBookingScrollRef = useRef(null)
    const [showHelperBookingArrow, setShowHelperBookingArrow] = useState(true)

    const { setRequestCriteria, setRequestDescription } = useContext(RequestContext);

    const override = {
        display: "block",
        margin: "auto"
    };

    const openRequestForm = () => {
        window.scrollTo({ top: 0 });
        openModal(setRequestForm)
        // setRequestForm(true)
    }
    
    const confirmBook = (criteria) => {
        setRequestCriteria(criteria)
        setRequestDescription('')
        setIsQuickBook(true)
        // setRequestForm(true)
        openModal(setRequestForm)
    }
    
    const quickBook = (hours) => {

        let criteria = [
            {0: "Part time helper", criteria: 'Type of service - Part time helper'},
            {1: helperType, criteria: 'Type of helper - ' + helperType},
            {11: 'Weekly', criteria: 'Frequency of service - Weekly'},
            {3: hours.toString(), criteria: "Length of each service in hours - " + hours}
        ]
        
        confirmBook(criteria)
    }
    
    useEffect(() => {
        setRequestCriteria([])
        setRequestDescription('')
        setIsQuickBook(false)
    }, [setIsQuickBook, setRequestCriteria, setRequestDescription])

    const fetchAppSetting = useCallback(async() => {
        try {
            const appSettings = await getAppSettings(countryName)
            setWaInd(appSettings.waBusinessInd)
        } catch (error) {
            console.log(error);
        }
    }, [countryName])
    
    useEffect(() => {
        if(!countryName) return

        fetchAppSetting()
    }, [countryName, fetchAppSetting])

    // Scroll functions for mobile helper booking buttons
    const scrollHelperBookingToNext = () => {
        const scrollContainer = helperBookingScrollRef.current;
        if (!scrollContainer) return;

        const cardWidth = scrollContainer.querySelector('div')?.offsetWidth || 0;
        scrollContainer.scrollBy({
            left: cardWidth,
            behavior: 'smooth'
        });
    };

    // Scroll detection effect for mobile helper booking buttons
    useEffect(() => {
        const helperContainer = helperBookingScrollRef.current;
        if (helperContainer) {
            const handleHelperScroll = () => {
                const { scrollLeft, scrollWidth, clientWidth } = helperContainer;
                const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 10;
                setShowHelperBookingArrow(!isAtEnd);
            };

            helperContainer.addEventListener('scroll', handleHelperScroll);
            handleHelperScroll();

            return () => helperContainer.removeEventListener('scroll', handleHelperScroll);
        }
    }, [])

    const DurationButton = ({ hours, rate, onClick }) => (
        <button
            type="button"
            className="text-white p-3 text-lg rounded-xl bg-linear-to-tr from-orange-600 to-amber-400 text-center space-y-1 w-24 sm:w-40"
            onClick={() => onClick(hours)}
        >
            <div className="text-base">{hours} hrs</div>
            <div>${rate}</div>
        </button>
    );

    const isSpecialService = helperType === "Elderly Care" || helperType === "Cooking Assistance";
    const rates = isSpecialService ? elderlyCareService : helperService;

  return (
    <>
        <div className="py-4 bg-white sm:bg-black/30 max-w-md sm:max-w-3xl mx-auto rounded-xl sm:text-white shadow">
            <div className="pt-2">
                {/* The hub passes a title (its <h1>) plus subtitle and trust pills.
                    The sub-pages keep their own <h1> and show the plain label. */}
                {title
                    ? <div className="pb-4">
                        <BookingCardHeader
                            title={title}
                            subtitle={subtitle}
                            pills={pills}
                            titleClassName="text-xl sm:text-2xl"
                            subtitleClassName="text-sm text-gray-600 sm:text-white/90"
                        />
                    </div>
                    : <p className="text-center font-bold leading-relaxed uppercase pb-2 px-1">
                        Part Time {helperType} Service
                    </p>
                }
                {/* Desktop Buttons */}
                <div className="hidden sm:grid sm:grid-cols-3 gap-5 text-center w-full pt-5">
                {HELPER_SERVICE_HOURS.map((hours, idx) => (
                    <div className="py-2" key={hours}>
                    <DurationButton hours={hours} rate={rates[idx].rate} onClick={quickBook} />
                    </div>
                ))}
                <div className="py-2">
                    <button
                    type="button"
                    className="text-white p-3 text-lg rounded-xl bg-linear-to-tr from-slate-700 to-slate-400 text-center w-40"
                    onClick={openRequestForm}
                    >
                    <div>More</div>
                    <div>Options</div>
                    </button>
                </div>
                </div>

                {/* Mobile Buttons */}
                    <div className="sm:hidden relative">
                    {/* <motion.div
                        className="absolute text-4xl text-amber-400 top-20 w-fit"
                        initial={{ x: "10%", y: "10%" }}
                        animate={{
                        x: ["40px", "180px", "280px", "390px", "280px", "180px", "40px"],
                        y: ["-25%", "0%", "-15%", "0%", "-25%", "10%", "-25%"]
                        }}
                        transition={{ delay: 0.5, ease: "easeInOut", duration: 10, repeat: Infinity }}
                    >
                        <GiClick />
                    </motion.div> */}

                    <div className="relative overflow-hidden">
                        <div
                            ref={helperBookingScrollRef}
                            className="overflow-auto scrollbar-hide whitespace-nowrap text-center w-full text-base"
                        >
                        {HELPER_SERVICE_HOURS.map((hours, idx) => (
                            <div className="w-[28%] min-w-25 inline-block py-2" key={hours}>
                                <DurationButton hours={hours} rate={rates[idx].rate} onClick={quickBook} />
                            </div>
                        ))}
                        </div>
                        {showHelperBookingArrow && (
                            <div
                                className="absolute right-0 top-1/2 -translate-y-1/2 z-10 cursor-pointer"
                                onClick={scrollHelperBookingToNext}
                            >
                                <div className='p-1 bg-gray-400 rounded-full shadow-lg animate-pulse'>
                                    <MdKeyboardArrowRight className="text-white text-2xl animate-pulse" />
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="flex justify-center items-center space-x-1 text-sm px-2 pt-2">
                        <span className="bg-white text-orange-600 text-xl rounded-full">
                        <MdDiscount />
                        </span>
                        <span>Submit request to check applied discounts!</span>
                    </div>

                    <div className="text-center pb-3 pt-5">
                        <button
                        type="button"
                        className="text-white text-sm py-3 px-4 rounded-xl bg-linear-to-tr from-slate-700 to-slate-400"
                        onClick={openRequestForm}
                        >
                        <span>More Options</span>
                        </button>
                    </div>
                </div>

                {/* Benefits List */}
                <div className="flex justify-center items-center pt-5 w-full text-sm px-2">
                    <div className="grid grid-cols-2 gap-3">
                        {["Cancel anytime", "All fees inclusive", "Legal workers", "Instant booking"].map((text, idx) => (
                        <div className="flex items-center space-x-2" key={idx}>
                            <span className="bg-white text-orange-600 text-xl rounded-full">
                            <FaCheckCircle />
                            </span>
                            <span>{text}</span>
                        </div>
                        ))}
                    </div>
                </div>

                {/* Scope Button */}
                <div className="text-center pt-8">
                <button
                    type="button"
                    className="text-orange-600 text-sm sm:text-white sm:text-base flex items-center justify-center w-full"
                    onClick={() => openModal(setIsShowJobScope)}
                >
                    <MdKeyboardDoubleArrowRight className="text-xl sm:text-2xl animate-pulse" />
                    <span>Service Scope&nbsp;</span>
                </button>
                </div>
            </div>
        </div>
    </>
  )
}
